import { useQuery } from 'react-query';
import qs from 'query-string';
import { API, APIRoutes, EXTENDED_STALE_TIME } from 'api';

const fetchContentComponents = async (isDashboard: boolean) => {
  const queryString = qs.stringify({
    'q[placement_eq]': isDashboard ? 'dashboard' : 'common',
  });
  const { data: contentComponents } = await API.get<ContentComponentResponse>(APIRoutes.contentComponents(queryString));
  return contentComponents;
};

const useGetContentComponents = (isDashboard: boolean) =>
  useQuery<ContentComponentResponse>(['contentComponents', isDashboard], () => fetchContentComponents(isDashboard), {
    staleTime: EXTENDED_STALE_TIME,
  });

export { useGetContentComponents };
